module.exports = __webpack_public_path__ + "img/xiaochengxu.44adaf1a.jpg";